import React, { useEffect, useRef, useState } from 'react';
import Header from '../components/Header';
import ContentRow from '../components/ContentRow';
import Footer from '../components/Footer';
import ContentModal from '../components/ContentModal';
import { setupHoverVideoHandlers } from '../utils/videoHandler';
import { useIsMobile } from '../hooks/use-mobile';

const Series = () => {
  const isMobile = useIsMobile();

  const seriesRef = useRef<HTMLDivElement | null>(null);
  const footerRef = useRef<HTMLDivElement | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState<any>(null);

  const openModal = (item: any) => {
    setModalData(item);
    setModalOpen(true);
  };

  const playFullscreen = () => {
    const video = videoRef.current;
    if (video) {
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if ((video as any).webkitEnterFullscreen) {
        (video as any).webkitEnterFullscreen();
      } else if ((video as any).mozRequestFullScreen) {
        (video as any).mozRequestFullScreen();
      } else if ((video as any).msRequestFullscreen) {
        (video as any).msRequestFullscreen();
      }
      video.play();
    }
  };

  useEffect(() => {
    setupHoverVideoHandlers();
  }, []);

  const destaque = {
    id: '1',
    title: 'A HISTÓRIA de GONZAGA',
    imageSrc: '/img/Luiz_Gonzaga.png',
    videoSrc: '/videos/Luiz_Gonzaga.mp4',
    embedId: 'bf8229696f7a3bb4700cfddef19fa23f',
    description: 'Uma série que retrata o sertão a história do Rei do Baião.'
  };

  const seriesPopulares = [
    destaque,
    {
      id: '2',
      title: 'Fazenda "É o Amor"',
      imageSrc: '/img/fazenda-é-o-amor.jpg',
      videoSrc: '/videos/fazenda_e_o_amor.mp4',
      embedId: '9766527f2b5d3e95d4a733fcfb77bd7e'
    },
    {
      id: '3',
      title: 'Zezé Di Camargo & Luciando',
      imageSrc: '/img/zeze&luciano.jpg',
      videoSrc: '/videos/zeze&luciano.mp4',
      embedId: '06409663226af2f3114485aa4e0a23b4'
    }
  ];

  const seriesNovas = [
    {
      id: '1',
      title: 'Victor e Leo',
      imageSrc: '/img/Victor_e_Leo.jpg',
      videoSrc: '/videos/victor_e_leo.mp4',
      embedId: 'b1d10e7bafa4421218a51b1e1f1b0ba2'
    },
    {
      id: '2',
      title: 'Chitão e Xororó',
      imageSrc: '/img/chitaozinho-e-xororo.jpg',
      videoSrc: '/videos/Chitaozinho_e_Xororo.mp4',
      embedId: '091d584fced301b442654dd8c23b3fc9'
    }
  ];

  return (
    <div className="bg-[#141414]">
      <Header />

      <main className="pt-[70px] sm:pt-[80px] md:pt-[90px] p-3 sm:p-4 md:p-5 overflow-visible relative">
        <div className="container mx-auto px-0 max-w-full">
          <div className="relative w-full h-[85vh] overflow-hidden rounded-lg shadow-lg mb-10">
            <video
              ref={videoRef}
              className="absolute inset-0 w-full h-full object-cover"
              src={destaque.videoSrc}
              autoPlay
              muted
              loop
              playsInline
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent flex flex-col justify-end p-8">
              <div className="max-w-[600px] bg-black/50 p-6 rounded-lg">
                <h1 className="text-white text-3xl md:text-4xl font-bold">
                  {destaque.title}
                </h1>
                <p className="text-white/90 text-sm md:text-base mt-2">
                  {destaque.description}
                </p>

                <div className="flex gap-4 mt-4 w-full max-w-[500px]">
                  <button
                    className="flex items-center justify-center gap-2 px-[20px] h-[48px] rounded font-bold text-rustico-brown bg-white hover:bg-[#bbab95] transition-colors flex-1"
                    onClick={playFullscreen}
                  >
                    <span className="material-symbols-outlined text-[20px]">play_arrow</span>
                    ASSISTIR
                  </button>
                  <button
                    className="flex items-center justify-center gap-2 px-[20px] h-[48px] rounded font-medium text-white bg-[rgba(109,109,110,0.7)] hover:bg-[rgba(109,109,110,0.9)] transition-colors flex-1"
                    onClick={() => openModal(destaque)}
                  >
                    INFORMAÇÕES
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div ref={seriesRef}>
            <ContentRow
              title="Séries Populares"
              items={seriesPopulares}
              category="series-populares"
              fullWidth={true}
            />
            <ContentRow
              title="Séries Novas"
              items={seriesNovas}
              category="series-novas"
              fullWidth={true}
            />
          </div>
        </div>
      </main>

      <div ref={footerRef}>
        <Footer />
      </div>

      {modalOpen && modalData && (
        <ContentModal item={modalData} onClose={() => setModalOpen(false)} />
      )}
    </div>
  );
};

export default Series;
